import LtCommon from '../../../types/lt/ltCommon';

export default function getMobileStore(): LtCommon.IMobileUtils {
	const mobileUtils = {} as LtCommon.IMobileUtils;

	if (/Mobi|Tablet|iPad|iPhone|android/.test(navigator.userAgent)) {
		mobileUtils.isMobile = true;

		if (/iPad|iPhone/.test(navigator.userAgent)) {
			mobileUtils.storeUrl = 'https://itunes.apple.com/us/app/life-time-vlt/id1441849511';
		} else {
			mobileUtils.storeUrl = 'https://play.google.com/store/apps/details?id=com.trainerize.lifetime';
		}
	} else {
		mobileUtils.isMobile = false;
	}

	return mobileUtils;
}
